import { useListContext, ListOfCollapsableDataItem } from 'framework/list';
import { ControlledShow } from 'framework/show';
import { SmallLoader } from 'framework/ui/mui-builder';
import { Box, Typography } from '@mui/material';
import BenchListItem from './BenchListItem';

const BENCH_COLLAPSE_SX = {
  marginBottom: '20px',
  borderRadius: '3px',
  border: '1px solid',
  borderColor: 'border.default',
  '& > .collapse-header-wrapper': {
    padding: '5px 0 5px 15px !important',
    border: '0 !important',
    '&::after': {
      left: '10px !important',
      border: '1px solid var(--mui-palette-text-primary) !important',
      borderTop: '0 !important',
      borderLeft: '0 !important',
      width: '6px !important',
      height: '6px !important',
      right: 'initial !important',
      top: '49% !important',
    },
    '&:hover, &:focus, &:active, &:last-child': {
      border: '0 !important',
    },
    '&:hover::after': {
      transform: 'translateY(-80%) rotate(45deg) scale(1.1) !important',
    },
    '&.collapse-header-wrapper--open': {
      borderBottom: 0,
      '&::after': {
        transform: 'translateY(-20%) rotate(225deg) !important',
        top: '49% !important',
      },
      '&:hover::after': {
        transform: 'translateY(-20%) rotate(225deg) scale(1.1) !important',
      },
    },
  },
};

const BenchCollapseZoneHeader = ({ countElements = 0, groupName }: { countElements: number; groupName: string }) => {
  const { loading } = useListContext();

  return (
    <Box px={0.6} py={0.6} pl={1.8} display="flex" alignItems="center" justifyContent="space-between">
      <Typography variant="subtitle2" display="flex">
        {groupName}
        &nbsp;
        {loading ? <SmallLoader size="10px" /> : ` (${countElements})`}
      </Typography>
    </Box>
  );
};

const BenchListLayout = () => {
  const { loading, data: { items = [] } = {} } = useListContext();

  const total = items.reduce(
    (acc, group) => {
      group.employees.forEach((emp: any) => {
        acc.min += emp.benchMinAssing;
        acc.max += emp.benchMaxAssing;
      });
      return acc;
    },
    { min: 0, max: 0 },
  );

  const renderItems = () =>
    items.map(impoyeeGroup => {
      return (
        <ListOfCollapsableDataItem
          items={impoyeeGroup.employees}
          sxWrapper={{
            minHeight: 'auto',
            p: '0 10px 10px 30px',
          }}
          sxCollapseWrapper={BENCH_COLLAPSE_SX}
          renderHeader={count => (
            <BenchCollapseZoneHeader groupName={impoyeeGroup.employeeSpecialization} countElements={count} />
          )}
          renderItem={(employee, update) => (
            <ControlledShow
              data={{
                ...employee,
              }}
              setData={update}
            >
              <BenchListItem />
            </ControlledShow>
          )}
        />
      );
    });

  return (
    <>
      {renderItems()}

      <Box
        sx={{
          borderRadius: '3px',
          border: '1px solid',
          borderColor: 'border.default',
        }}
        p="10px 5px 10px 30px"
        display="flex"
        alignItems="center"
      >
        <Typography variant="subtitle2" display="flex" flexBasis="42%">
          Total {loading ? <SmallLoader size="10px" /> : ` (${items.length})`}
        </Typography>

        <Typography variant="subtitle2">{loading ? null : `${total.min}% - ${total.max}%`}</Typography>
      </Box>
    </>
  );
};

export default BenchListLayout;
